import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MapPin } from "lucide-react";
import api, { mediaUrl, timeAgo } from "@/lib/api";
import { ListingCard, Stars } from "@/components/market/MarketUI";
import { Loader, EmptyState } from "@/components/Loader";

export default function SellerPage() {
  const { id } = useParams();
  const [data, setData] = useState(undefined);
  const [listings, setListings] = useState([]);

  useEffect(() => {
    api.get(`/market/sellers/${id}`).then((r) => setData(r.data)).catch(() => setData(null));
    api.get("/market/listings", { params: { seller_id: id, limit: 48 } }).then((r) => setListings(r.data.items));
  }, [id]);

  if (data === undefined) return <Loader full />;
  if (data === null) return <EmptyState title="Vendedor não encontrado." />;
  const s = data.seller;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex flex-col gap-5 rounded-2xl border border-border bg-card p-6 sm:flex-row sm:items-center">
        <img src={mediaUrl(s.avatar)} alt="" className="h-20 w-20 rounded-2xl object-cover" />
        <div className="flex-1">
          <h1 className="text-3xl font-extrabold tracking-tight" data-testid="seller-store-name">{s.store_name}</h1>
          <p className="mt-1 flex items-center gap-1 text-sm text-muted-foreground"><MapPin className="h-4 w-4" /> {s.city}/{s.state}</p>
          {s.about && <p className="mt-2 text-sm text-muted-foreground max-w-2xl">{s.about}</p>}
        </div>
        <div className="text-left sm:text-right" data-testid="seller-rating">
          <p className="text-3xl font-extrabold">{s.reviews_count ? s.rating : "—"}</p>
          <Stars value={s.rating} />
          <p className="text-xs text-muted-foreground">{s.reviews_count} avaliação(ões)</p>
        </div>
      </div>

      <h2 className="mt-10 text-lg font-bold">Anúncios</h2>
      {listings.length ? (
        <div className="mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">{listings.map((l, i) => <ListingCard key={l.id} listing={l} index={i} />)}</div>
      ) : <p className="mt-3 text-sm text-muted-foreground">Nenhum anúncio ativo.</p>}

      <h2 className="mt-10 text-lg font-bold">Avaliações</h2>
      <div className="mt-4 space-y-3">
        {data.reviews.length ? data.reviews.map((r) => (
          <div key={r.id} data-testid={`review-${r.id}`} className="rounded-2xl border border-border bg-card p-4">
            <div className="flex items-center gap-3">
              <img src={mediaUrl(r.buyer?.avatar)} alt="" className="h-8 w-8 rounded-full object-cover" />
              <div className="flex-1"><p className="text-sm font-semibold">{r.buyer?.name}</p><p className="text-xs text-muted-foreground">{r.listing_title} · {timeAgo(r.created_at)}</p></div>
              <Stars value={r.rating} size="h-3.5 w-3.5" />
            </div>
            {r.comment && <p className="mt-2 text-sm">{r.comment}</p>}
          </div>
        )) : <p className="text-sm text-muted-foreground">Ainda sem avaliações.</p>}
      </div>
    </div>
  );
}
